const ACTIVE_KEY = "datalyze-tutorial-journey-active";
const STAGE_KEY = "datalyze-tutorial-journey-stage";
const COMPLETED_KEY = "datalyze-full-journey-completed";

export const STAGES = {
    PRELOAD: "preload",
    DOMAINS: "domains",
    PROBLEMS: "problems",
    GAMEPLAY: "gameplay",
    DONE: "done",
};

const STAGE_ORDER = [STAGES.PRELOAD, STAGES.DOMAINS, STAGES.PROBLEMS, STAGES.GAMEPLAY, STAGES.DONE];

export function isJourneyActive() {
    return localStorage.getItem(ACTIVE_KEY) === "true";
}

export function getJourneyStage() {
    return localStorage.getItem(STAGE_KEY) || null;
}

export function isJourneyCompleted() {
    return localStorage.getItem(COMPLETED_KEY) === "true";
}

export function startJourney(fromStage = STAGES.PRELOAD) {
    localStorage.setItem(ACTIVE_KEY, "true");
    localStorage.setItem(STAGE_KEY, fromStage);
    localStorage.removeItem(COMPLETED_KEY);
}

export function advanceStage() {
    const current = getJourneyStage();
    const idx = STAGE_ORDER.indexOf(current);
    if (idx === -1 || idx >= STAGE_ORDER.length - 1) {
        completeJourney();
        return;
    }
    localStorage.setItem(STAGE_KEY, STAGE_ORDER[idx + 1]);
}

export function setStage(stage) {
    localStorage.setItem(STAGE_KEY, stage);
}

export function completeJourney() {
    localStorage.setItem(ACTIVE_KEY, "false");
    localStorage.setItem(STAGE_KEY, STAGES.DONE);
    localStorage.setItem(COMPLETED_KEY, "true");
}

export function resetJourney(fromStage = STAGES.PRELOAD) {
    localStorage.removeItem(COMPLETED_KEY);
    localStorage.setItem(ACTIVE_KEY, "true");
    localStorage.setItem(STAGE_KEY, fromStage);
}

/**
 * Enriches a request body with isTutorialMode when the user is in the tutorial flow.
 * Use when calling activity/tracking APIs (e.g. trackings/PATCH).
 */
export function withTutorialMode(body) {
    if (!body || typeof body !== "object") return body;
    return { ...body, isTutorialMode: isJourneyActive() };
}
